import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountTransferPage} from 'features/deposit/transfer/DepositAccountTransferPage';

export const Route = createFileRoute('/_protected/transfer/$accountId')({
  component: DepositAccountTransferPage,
});
